import React from 'react';

export const MainLogoDark = () => (
  <svg width="105" height="54" viewBox="0 0 105 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.9994 27.0077C28.9994 20.3768 23.5999 14.9834 16.969 15C10.3899 15.0167 5.01603 20.3935 5.00004 26.9769C4.98341 33.6116 10.3726 39.0153 16.9997 39.0153H24.8845C27.1531 39.0153 28.9923 37.1748 28.9923 34.9048V27.4078C28.9968 27.2753 28.9994 27.1421 28.9994 27.0077ZM10.8287 33.6763C8.91846 32.0445 7.74134 29.4339 7.79572 26.7721C7.79955 26.5858 7.80915 26.3989 7.82514 26.2132L7.82642 26.2011C8.10279 23.0252 10.1525 20.0631 13.0263 18.6874C15.9 17.3117 19.4915 17.5742 22.1356 19.3519C24.7796 21.1296 26.3783 24.3587 26.1915 27.5409C26.1506 28.2374 26.0303 28.9282 25.8627 29.6055C25.7962 29.875 25.7156 30.1541 25.5249 30.3557C25.3343 30.5574 25.0003 30.6509 24.7745 30.4895C24.5589 30.3359 24.5269 30.0337 24.5084 29.77C24.3593 27.6338 23.7893 25.4316 22.3467 23.8504C21.2572 22.6564 19.709 21.8966 18.1001 21.7474C16.4911 21.5983 14.8361 22.0579 13.5227 22.9996C12.4243 23.7876 11.5606 24.915 11.1435 26.2017C10.7264 27.4884 10.7692 28.9295 11.3175 30.1663C11.7199 31.074 12.3884 31.8621 13.2182 32.4075C14.6851 33.3716 16.6926 33.5086 18.2171 32.638C19.7416 31.7673 20.6526 29.8788 20.2643 28.1657C19.876 26.4526 18.141 25.1166 16.3951 25.2971C16.1284 25.3247 15.7471 25.2959 15.7375 25.0276C15.7298 24.8202 15.9787 24.7107 16.1827 24.6743C17.9542 24.3561 19.8517 25.2562 20.8234 26.7721C21.7952 28.288 21.8445 30.3186 21.0512 31.935C20.2579 33.5515 18.6822 34.7326 16.9338 35.1589C14.577 35.7338 12.4428 35.0539 10.8307 33.6763H10.8287Z"
      fill="url(#paint0_linear_1571_32180)"
    />
    <path
      d="M47.82 21.86C47.56 22.26 47.3 22.66 47.04 23.02H56.9C56.84 24.74 56.78 26.26 56.74 27.62H58.28V29.54H56.66C56.6 30.66 56.54 31.62 56.5 32.4H57.96V34.2H56.36C56.32 34.68 56.26 35 56.22 35.14C56.02 35.8 55.64 36.28 55.1 36.58C54.54 36.88 53.72 37.04 52.64 37.04C52.08 37.04 51.42 37.06 50.7 37.06L50.08 35.2C50.92 35.24 51.68 35.28 52.36 35.28C52.82 35.28 53.22 35.22 53.56 35.14C53.9 35.02 54.16 34.76 54.34 34.38C54.34 34.34 54.36 34.28 54.38 34.2H44.92C45.24 32.62 45.52 31.06 45.72 29.54H43.96V27.62H45.94C46.06 26.42 46.16 25.22 46.22 24.06C45.94 24.38 45.64 24.7 45.36 24.98L44.04 23.38C45.28 22.2 46.36 20.52 47.28 18.36L49.36 18.82L48.86 19.94H57.68V21.86H47.82ZM47.72 29.54C47.58 30.56 47.42 31.52 47.24 32.4H51.34C50.78 31.8 50.02 31.18 49.1 30.52L50.12 29.54H47.72ZM51.72 32.4H54.54C54.58 31.64 54.62 30.68 54.68 29.54H50.8C51.6 30.1 52.3 30.68 52.86 31.26L51.72 32.4ZM54.76 27.62C54.78 26.74 54.82 25.82 54.86 24.82H50.72C51.64 25.4 52.44 25.98 53.1 26.54L52 27.62H54.76ZM50.56 24.82H48.12C48.08 25.8 48 26.74 47.92 27.62H51.5C50.94 27.1 50.2 26.58 49.32 26.02L50.56 24.82ZM41.58 18.74C42.76 19.58 43.76 20.42 44.56 21.28L43.08 22.76C42.38 21.96 41.38 21.1 40.1 20.18L41.58 18.74ZM41.26 23.6C42.44 24.46 43.44 25.32 44.26 26.2L42.78 27.68C42.08 26.88 41.08 26 39.78 25.04L41.26 23.6ZM42.74 29.6L44.56 30.32C43.76 32.64 42.84 34.8 41.84 36.84L39.9 35.98C40.98 33.9 41.94 31.76 42.74 29.6ZM68.46 19.12H77.78V26.08H73.6C72.9 26.68 72.22 27.2 71.58 27.64C72.42 27.56 73.24 27.44 74.06 27.32C74.46 27 74.82 26.68 75.18 26.38L77.06 27.1C75.36 28.48 73.7 29.62 72.06 30.54C73.28 30.44 74.5 30.32 75.72 30.18C75.48 29.84 75.24 29.52 75 29.24L76.5 28.56C77.34 29.48 78.06 30.48 78.7 31.6L77.1 32.42C76.94 32.1 76.76 31.82 76.6 31.54C75.82 31.62 75.06 31.68 74.3 31.76V34.76C74.3 36.24 73.7 36.98 72.54 36.98H71.2L70.78 35.2C71.18 35.28 71.54 35.32 71.9 35.32C72.24 35.32 72.42 34.96 72.42 34.28V31.92C71.16 32.02 69.9 32.1 68.66 32.14L68.28 30.84C69.56 30.24 70.74 29.58 71.84 28.88C70.84 29 69.86 29.08 68.88 29.14L68.54 27.92C69.46 27.36 70.32 26.76 71.1 26.08H68.46V19.12ZM75.9 24.48V23.3H74.02V24.48H75.9ZM72.28 24.48V23.3H70.34V24.48H72.28ZM70.34 21.82H72.28V20.72H70.34V21.82ZM74.02 20.72V21.82H75.9V20.72H74.02ZM69.32 32.42L70.84 33.18C70.16 34.64 69.38 35.9 68.5 36.98L67.02 35.92C67.3 35.6 67.58 35.26 67.82 34.94L66.64 35.24C66.58 34.92 66.52 34.6 66.46 34.32C64.62 34.96 62.7 35.52 60.66 36L60.18 34.06C61.14 33.92 62.08 33.74 63 33.54V30.04H60.58V21.68H63.04V18.56H65.02V21.68H67.44V30.04H64.9V33.06L66.1 32.7C65.94 32.1 65.78 31.52 65.62 30.96L67.1 30.48C67.5 31.64 67.84 32.98 68.14 34.48C68.58 33.84 68.98 33.14 69.32 32.42ZM76.58 32.32C77.54 33.6 78.3 34.7 78.84 35.66L77.3 36.7C76.76 35.66 76.04 34.48 75.14 33.2L76.58 32.32ZM63.18 23.48H62.32V28.24H63.18V23.48ZM64.86 28.24H65.68V23.48H64.86V28.24ZM96.6402 31.9H90.5602L89.4402 35H87.5202L92.5602 21.14H94.6602L99.6802 35H97.7602L96.6402 31.9ZM96.1202 30.42L93.6002 23.38L91.0802 30.42H96.1202ZM104.097 21.06V35H102.277V21.06H104.097Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1571_32180"
        x1="5.5387"
        y1="15.8848"
        x2="32.5039"
        y2="42.0209"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.09" stopColor="#FFAB0C" />
        <stop offset="0.31" stopColor="#FF5538" />
        <stop offset="0.46" stopColor="#E9405D" />
        <stop offset="0.75" stopColor="#D266DA" />
        <stop offset="0.89" stopColor="#D584EF" />
      </linearGradient>
    </defs>
  </svg>
);

//

export const MainLogo = () => (
  <svg width="105" height="54" viewBox="0 0 105 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.9994 27.0077C28.9994 20.3768 23.5999 14.9834 16.969 15C10.3899 15.0167 5.01603 20.3935 5.00004 26.9769C4.98341 33.6116 10.3726 39.0153 16.9997 39.0153H24.8845C27.1531 39.0153 28.9923 37.1748 28.9923 34.9048V27.4078C28.9968 27.2753 28.9994 27.1421 28.9994 27.0077ZM10.8287 33.6763C8.91846 32.0445 7.74134 29.4339 7.79572 26.7721C7.79955 26.5858 7.80915 26.3989 7.82514 26.2132L7.82642 26.2011C8.10279 23.0252 10.1525 20.0631 13.0263 18.6874C15.9 17.3117 19.4915 17.5742 22.1356 19.3519C24.7796 21.1296 26.3783 24.3587 26.1915 27.5409C26.1506 28.2374 26.0303 28.9282 25.8627 29.6055C25.7962 29.875 25.7156 30.1541 25.5249 30.3557C25.3343 30.5574 25.0003 30.6509 24.7745 30.4895C24.5589 30.3359 24.5269 30.0337 24.5084 29.77C24.3593 27.6338 23.7893 25.4316 22.3467 23.8504C21.2572 22.6564 19.709 21.8966 18.1001 21.7474C16.4911 21.5983 14.8361 22.0579 13.5227 22.9996C12.4243 23.7876 11.5606 24.915 11.1435 26.2017C10.7264 27.4884 10.7692 28.9295 11.3175 30.1663C11.7199 31.074 12.3884 31.8621 13.2182 32.4075C14.6851 33.3716 16.6926 33.5086 18.2171 32.638C19.7416 31.7673 20.6526 29.8788 20.2643 28.1657C19.876 26.4526 18.141 25.1166 16.3951 25.2971C16.1284 25.3247 15.7471 25.2959 15.7375 25.0276C15.7298 24.8202 15.9787 24.7107 16.1827 24.6743C17.9542 24.3561 19.8517 25.2562 20.8234 26.7721C21.7952 28.288 21.8445 30.3186 21.0512 31.935C20.2579 33.5515 18.6822 34.7326 16.9338 35.1589C14.577 35.7338 12.4428 35.0539 10.8307 33.6763H10.8287Z"
      fill="url(#paint0_linear_1571_32058)"
    />
    <path
      d="M47.82 21.86C47.56 22.26 47.3 22.66 47.04 23.02H56.9C56.84 24.74 56.78 26.26 56.74 27.62H58.28V29.54H56.66C56.6 30.66 56.54 31.62 56.5 32.4H57.96V34.2H56.36C56.32 34.68 56.26 35 56.22 35.14C56.02 35.8 55.64 36.28 55.1 36.58C54.54 36.88 53.72 37.04 52.64 37.04C52.08 37.04 51.42 37.06 50.7 37.06L50.08 35.2C50.92 35.24 51.68 35.28 52.36 35.28C52.82 35.28 53.22 35.22 53.56 35.14C53.9 35.02 54.16 34.76 54.34 34.38C54.34 34.34 54.36 34.28 54.38 34.2H44.92C45.24 32.62 45.52 31.06 45.72 29.54H43.96V27.62H45.94C46.06 26.42 46.16 25.22 46.22 24.06C45.94 24.38 45.64 24.7 45.36 24.98L44.04 23.38C45.28 22.2 46.36 20.52 47.28 18.36L49.36 18.82L48.86 19.94H57.68V21.86H47.82ZM47.72 29.54C47.58 30.56 47.42 31.52 47.24 32.4H51.34C50.78 31.8 50.02 31.18 49.1 30.52L50.12 29.54H47.72ZM51.72 32.4H54.54C54.58 31.64 54.62 30.68 54.68 29.54H50.8C51.6 30.1 52.3 30.68 52.86 31.26L51.72 32.4ZM54.76 27.62C54.78 26.74 54.82 25.82 54.86 24.82H50.72C51.64 25.4 52.44 25.98 53.1 26.54L52 27.62H54.76ZM50.56 24.82H48.12C48.08 25.8 48 26.74 47.92 27.62H51.5C50.94 27.1 50.2 26.58 49.32 26.02L50.56 24.82ZM41.58 18.74C42.76 19.58 43.76 20.42 44.56 21.28L43.08 22.76C42.38 21.96 41.38 21.1 40.1 20.18L41.58 18.74ZM41.26 23.6C42.44 24.46 43.44 25.32 44.26 26.2L42.78 27.68C42.08 26.88 41.08 26 39.78 25.04L41.26 23.6ZM42.74 29.6L44.56 30.32C43.76 32.64 42.84 34.8 41.84 36.84L39.9 35.98C40.98 33.9 41.94 31.76 42.74 29.6ZM68.46 19.12H77.78V26.08H73.6C72.9 26.68 72.22 27.2 71.58 27.64C72.42 27.56 73.24 27.44 74.06 27.32C74.46 27 74.82 26.68 75.18 26.38L77.06 27.1C75.36 28.48 73.7 29.62 72.06 30.54C73.28 30.44 74.5 30.32 75.72 30.18C75.48 29.84 75.24 29.52 75 29.24L76.5 28.56C77.34 29.48 78.06 30.48 78.7 31.6L77.1 32.42C76.94 32.1 76.76 31.82 76.6 31.54C75.82 31.62 75.06 31.68 74.3 31.76V34.76C74.3 36.24 73.7 36.98 72.54 36.98H71.2L70.78 35.2C71.18 35.28 71.54 35.32 71.9 35.32C72.24 35.32 72.42 34.96 72.42 34.28V31.92C71.16 32.02 69.9 32.1 68.66 32.14L68.28 30.84C69.56 30.24 70.74 29.58 71.84 28.88C70.84 29 69.86 29.08 68.88 29.14L68.54 27.92C69.46 27.36 70.32 26.76 71.1 26.08H68.46V19.12ZM75.9 24.48V23.3H74.02V24.48H75.9ZM72.28 24.48V23.3H70.34V24.48H72.28ZM70.34 21.82H72.28V20.72H70.34V21.82ZM74.02 20.72V21.82H75.9V20.72H74.02ZM69.32 32.42L70.84 33.18C70.16 34.64 69.38 35.9 68.5 36.98L67.02 35.92C67.3 35.6 67.58 35.26 67.82 34.94L66.64 35.24C66.58 34.92 66.52 34.6 66.46 34.32C64.62 34.96 62.7 35.52 60.66 36L60.18 34.06C61.14 33.92 62.08 33.74 63 33.54V30.04H60.58V21.68H63.04V18.56H65.02V21.68H67.44V30.04H64.9V33.06L66.1 32.7C65.94 32.1 65.78 31.52 65.62 30.96L67.1 30.48C67.5 31.64 67.84 32.98 68.14 34.48C68.58 33.84 68.98 33.14 69.32 32.42ZM76.58 32.32C77.54 33.6 78.3 34.7 78.84 35.66L77.3 36.7C76.76 35.66 76.04 34.48 75.14 33.2L76.58 32.32ZM63.18 23.48H62.32V28.24H63.18V23.48ZM64.86 28.24H65.68V23.48H64.86V28.24ZM96.6402 31.9H90.5602L89.4402 35H87.5202L92.5602 21.14H94.6602L99.6802 35H97.7602L96.6402 31.9ZM96.1202 30.42L93.6002 23.38L91.0802 30.42H96.1202ZM104.097 21.06V35H102.277V21.06H104.097Z"
      fill="#222222"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1571_32058"
        x1="5.5387"
        y1="15.8848"
        x2="32.5039"
        y2="42.0209"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.09" stopColor="#FFAB0C" />
        <stop offset="0.31" stopColor="#FF5538" />
        <stop offset="0.46" stopColor="#E9405D" />
        <stop offset="0.75" stopColor="#D266DA" />
        <stop offset="0.89" stopColor="#D584EF" />
      </linearGradient>
    </defs>
  </svg>
);

export const MainLogoHilo = () => (
  <svg width="145" height="54" viewBox="0 0 145 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.7" filter="url(#filter0_f_974_27803)">
      <circle cx="21.5" cy="27.5" r="7.5" fill="url(#paint0_linear_974_27803)" />
    </g>
    <path
      d="M33.9994 27.0077C33.9994 20.3768 28.5999 14.9834 21.969 15C15.3899 15.0167 10.016 20.3935 10 26.9769C9.98341 33.6116 15.3726 39.0153 21.9997 39.0153H29.8845C32.1531 39.0153 33.9923 37.1748 33.9923 34.9048V27.4078C33.9968 27.2753 34 27.1421 34 27.0077H33.9994ZM15.8287 33.6763C13.9185 32.0445 12.7413 29.4339 12.7957 26.7721C12.7996 26.5858 12.8092 26.3989 12.8251 26.2132L12.8264 26.2011C13.1028 23.0252 15.1525 20.0631 18.0263 18.6874C20.9 17.3117 24.4915 17.5742 27.1356 19.3519C29.7796 21.1296 31.3783 24.3587 31.1915 27.5409C31.1506 28.2374 31.0303 28.9282 30.8627 29.6055C30.7962 29.875 30.7156 30.1541 30.5249 30.3557C30.3343 30.5574 30.0003 30.6509 29.7745 30.4895C29.5589 30.3359 29.5269 30.0337 29.5084 29.77C29.3593 27.6338 28.7893 25.4316 27.3467 23.8504C26.2572 22.6564 24.709 21.8966 23.1001 21.7474C21.4911 21.5983 19.8361 22.0579 18.5227 22.9996C17.4243 23.7876 16.5606 24.915 16.1435 26.2017C15.7264 27.4884 15.7692 28.9295 16.3175 30.1663C16.7199 31.074 17.3884 31.8621 18.2182 32.4075C19.6851 33.3716 21.6926 33.5086 23.2171 32.638C24.7416 31.7673 25.6526 29.8788 25.2643 28.1657C24.876 26.4526 23.141 25.1166 21.3951 25.2971C21.1284 25.3247 20.7471 25.2959 20.7375 25.0276C20.7298 24.8202 20.9787 24.7107 21.1827 24.6743C22.9542 24.3561 24.8517 25.2562 25.8234 26.7721C26.7952 28.288 26.8445 30.3186 26.0512 31.935C25.2579 33.5515 23.6822 34.7326 21.9338 35.1589C19.577 35.7338 17.4428 35.0539 15.8307 33.6763H15.8287Z"
      fill="url(#paint1_linear_974_27803)"
    />
    <path
      d="M58.74 19.556V35H54.978V28.642H49.126V35H45.364V19.556H49.126V25.606H54.978V19.556H58.74ZM61.1478 28.84C61.1478 27.5787 61.3825 26.4713 61.8518 25.518C62.3358 24.5647 62.9885 23.8313 63.8098 23.318C64.6311 22.8047 65.5478 22.548 66.5598 22.548C67.4251 22.548 68.1805 22.724 68.8258 23.076C69.4858 23.428 69.9918 23.89 70.3438 24.462V22.724H74.1058V35H70.3438V33.262C69.9771 33.834 69.4638 34.296 68.8038 34.648C68.1585 35 67.4031 35.176 66.5378 35.176C65.5405 35.176 64.6311 34.9193 63.8098 34.406C62.9885 33.878 62.3358 33.1373 61.8518 32.184C61.3825 31.216 61.1478 30.1013 61.1478 28.84ZM70.3438 28.862C70.3438 27.9233 70.0798 27.1827 69.5518 26.64C69.0385 26.0973 68.4078 25.826 67.6598 25.826C66.9118 25.826 66.2738 26.0973 65.7458 26.64C65.2325 27.168 64.9758 27.9013 64.9758 28.84C64.9758 29.7787 65.2325 30.5267 65.7458 31.084C66.2738 31.6267 66.9118 31.898 67.6598 31.898C68.4078 31.898 69.0385 31.6267 69.5518 31.084C70.0798 30.5413 70.3438 29.8007 70.3438 28.862ZM79.1594 21.448C78.4994 21.448 77.9568 21.2573 77.5314 20.876C77.1208 20.48 76.9154 19.996 76.9154 19.424C76.9154 18.8373 77.1208 18.3533 77.5314 17.972C77.9568 17.576 78.4994 17.378 79.1594 17.378C79.8048 17.378 80.3328 17.576 80.7434 17.972C81.1688 18.3533 81.3814 18.8373 81.3814 19.424C81.3814 19.996 81.1688 20.48 80.7434 20.876C80.3328 21.2573 79.8048 21.448 79.1594 21.448ZM81.0294 22.724V35H77.2674V22.724H81.0294ZM87.9577 18.72V35H84.1957V18.72H87.9577ZM103.246 22.724V35H99.484V33.328C99.1027 33.8707 98.582 34.3107 97.922 34.648C97.2767 34.9707 96.558 35.132 95.766 35.132C94.8273 35.132 93.9987 34.9267 93.28 34.516C92.5613 34.0907 92.004 33.482 91.608 32.69C91.212 31.898 91.014 30.9667 91.014 29.896V22.724H94.754V29.39C94.754 30.2113 94.9667 30.8493 95.392 31.304C95.8173 31.7587 96.3893 31.986 97.108 31.986C97.8413 31.986 98.4207 31.7587 98.846 31.304C99.2713 30.8493 99.484 30.2113 99.484 29.39V22.724H103.246ZM111.976 35.176C110.774 35.176 109.688 34.9193 108.72 34.406C107.767 33.8927 107.012 33.1593 106.454 32.206C105.912 31.2527 105.64 30.138 105.64 28.862C105.64 27.6007 105.919 26.4933 106.476 25.54C107.034 24.572 107.796 23.8313 108.764 23.318C109.732 22.8047 110.818 22.548 112.02 22.548C113.223 22.548 114.308 22.8047 115.276 23.318C116.244 23.8313 117.007 24.572 117.564 25.54C118.122 26.4933 118.4 27.6007 118.4 28.862C118.4 30.1233 118.114 31.238 117.542 32.206C116.985 33.1593 116.215 33.8927 115.232 34.406C114.264 34.9193 113.179 35.176 111.976 35.176ZM111.976 31.92C112.695 31.92 113.304 31.656 113.802 31.128C114.316 30.6 114.572 29.8447 114.572 28.862C114.572 27.8793 114.323 27.124 113.824 26.596C113.34 26.068 112.739 25.804 112.02 25.804C111.287 25.804 110.678 26.068 110.194 26.596C109.71 27.1093 109.468 27.8647 109.468 28.862C109.468 29.8447 109.703 30.6 110.172 31.128C110.656 31.656 111.258 31.92 111.976 31.92ZM135.332 31.59H128.644L127.412 35H125.3L130.844 19.754H133.154L138.676 35H136.564L135.332 31.59ZM134.76 29.962L131.988 22.218L129.216 29.962H134.76ZM143.534 19.666V35H141.532V19.666H143.534Z"
      fill="black"
    />
    <mask id="mask0_974_27803" maskUnits="userSpaceOnUse" x="45" y="17" width="99" height="19">
      <path d="M143.533 19.666V35H141.531V19.666H143.533Z" fill="black" />
      <path
        d="M135.331 31.5899H128.643L127.411 34.9999H125.299L130.843 19.7539H133.153L138.675 34.9999H136.563L135.331 31.5899ZM134.759 29.9619L131.987 22.2179L129.215 29.9619H134.759Z"
        fill="black"
      />
      <path
        d="M111.975 35.1759C110.772 35.1759 109.687 34.9192 108.719 34.4059C107.765 33.8925 107.01 33.1592 106.453 32.2059C105.91 31.2525 105.639 30.1379 105.639 28.8619C105.639 27.6005 105.917 26.4932 106.475 25.5399C107.032 24.5719 107.795 23.8312 108.763 23.3179C109.731 22.8045 110.816 22.5479 112.019 22.5479C113.221 22.5479 114.307 22.8045 115.275 23.3179C116.243 23.8312 117.005 24.5719 117.563 25.5399C118.12 26.4932 118.399 27.6005 118.399 28.8619C118.399 30.1232 118.113 31.2379 117.541 32.2059C116.983 33.1592 116.213 33.8925 115.231 34.4059C114.263 34.9192 113.177 35.1759 111.975 35.1759ZM111.975 31.9199C112.693 31.9199 113.302 31.6559 113.801 31.1279C114.314 30.5999 114.571 29.8445 114.571 28.8619C114.571 27.8792 114.321 27.1239 113.823 26.5959C113.339 26.0679 112.737 25.8039 112.019 25.8039C111.285 25.8039 110.677 26.0679 110.193 26.5959C109.709 27.1092 109.467 27.8645 109.467 28.8619C109.467 29.8445 109.701 30.5999 110.171 31.1279C110.655 31.6559 111.256 31.9199 111.975 31.9199Z"
        fill="black"
      />
      <path
        d="M103.246 22.7241V35.0001H99.4837V33.3281C99.1023 33.8708 98.5817 34.3108 97.9217 34.6481C97.2763 34.9708 96.5577 35.1321 95.7657 35.1321C94.827 35.1321 93.9983 34.9268 93.2797 34.5161C92.561 34.0908 92.0037 33.4821 91.6077 32.6901C91.2117 31.8981 91.0137 30.9668 91.0137 29.8961V22.7241H94.7537V29.3901C94.7537 30.2115 94.9663 30.8495 95.3917 31.3041C95.817 31.7588 96.389 31.9861 97.1077 31.9861C97.841 31.9861 98.4203 31.7588 98.8457 31.3041C99.271 30.8495 99.4837 30.2115 99.4837 29.3901V22.7241H103.246Z"
        fill="black"
      />
      <path d="M87.9573 18.7197V34.9997H84.1953V18.7197H87.9573Z" fill="black" />
      <path
        d="M79.1581 21.4479C78.4981 21.4479 77.9554 21.2573 77.5301 20.8759C77.1194 20.4799 76.9141 19.9959 76.9141 19.4239C76.9141 18.8373 77.1194 18.3533 77.5301 17.9719C77.9554 17.5759 78.4981 17.3779 79.1581 17.3779C79.8034 17.3779 80.3314 17.5759 80.7421 17.9719C81.1674 18.3533 81.3801 18.8373 81.3801 19.4239C81.3801 19.9959 81.1674 20.4799 80.7421 20.8759C80.3314 21.2573 79.8034 21.4479 79.1581 21.4479ZM81.0281 22.7239V34.9999H77.2661V22.7239H81.0281Z"
        fill="black"
      />
      <path
        d="M61.1465 28.8399C61.1465 27.5785 61.3812 26.4712 61.8505 25.5179C62.3345 24.5645 62.9872 23.8312 63.8085 23.3179C64.6298 22.8045 65.5465 22.5479 66.5585 22.5479C67.4238 22.5479 68.1792 22.7239 68.8245 23.0759C69.4845 23.4279 69.9905 23.8899 70.3425 24.4619V22.7239H74.1045V34.9999H70.3425V33.2619C69.9758 33.8339 69.4625 34.2959 68.8025 34.6479C68.1572 34.9999 67.4018 35.1759 66.5365 35.1759C65.5392 35.1759 64.6298 34.9192 63.8085 34.4059C62.9872 33.8779 62.3345 33.1372 61.8505 32.1839C61.3812 31.2159 61.1465 30.1012 61.1465 28.8399ZM70.3425 28.8619C70.3425 27.9232 70.0785 27.1825 69.5505 26.6399C69.0372 26.0972 68.4065 25.8259 67.6585 25.8259C66.9105 25.8259 66.2725 26.0972 65.7445 26.6399C65.2312 27.1679 64.9745 27.9012 64.9745 28.8399C64.9745 29.7785 65.2312 30.5265 65.7445 31.0839C66.2725 31.6265 66.9105 31.8979 67.6585 31.8979C68.4065 31.8979 69.0372 31.6265 69.5505 31.0839C70.0785 30.5412 70.3425 29.8005 70.3425 28.8619Z"
        fill="black"
      />
      <path
        d="M58.7393 19.5562V35.0002H54.9773V28.6422H49.1253V35.0002H45.3633V19.5562H49.1253V25.6062H54.9773V19.5562H58.7393Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0_974_27803)">
      <g opacity="0.3" filter="url(#filter1_f_974_27803)">
        <path
          d="M62 14C62 20.0751 51.0479 30 43.5593 30C36.0707 30 30 25.0751 30 19C30 12.9249 36.0707 8.00004 43.5593 8.00004C51.0479 8.00004 62 7.92487 62 14Z"
          fill="#AD14FF"
        />
      </g>
      <g opacity="0.4" filter="url(#filter2_f_974_27803)">
        <path
          d="M95 12.3636C95 16.7819 83.3634 24 75.4068 24C67.4501 24 61 20.4183 61 16C61 11.5817 67.4501 8.00003 75.4068 8.00003C83.3634 8.00003 95 7.94536 95 12.3636Z"
          fill="#AD14FF"
        />
      </g>
      <g opacity="0.4" filter="url(#filter3_f_974_27803)">
        <ellipse cx="51.5" cy="37.5" rx="12.5" ry="5.5" fill="#FF3617" />
      </g>
      <g opacity="0.3" filter="url(#filter4_f_974_27803)">
        <ellipse cx="41.5" cy="35.5" rx="7.5" ry="5.5" fill="#FF17D1" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_974_27803"
        x="0"
        y="6"
        width="43"
        height="43"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_974_27803" />
      </filter>
      <filter
        id="filter1_f_974_27803"
        x="20"
        y="-2"
        width="52"
        height="42"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_974_27803" />
      </filter>
      <filter
        id="filter2_f_974_27803"
        x="49"
        y="-4"
        width="58"
        height="40"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_974_27803" />
      </filter>
      <filter
        id="filter3_f_974_27803"
        x="29"
        y="22"
        width="45"
        height="31"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_974_27803" />
      </filter>
      <filter
        id="filter4_f_974_27803"
        x="25"
        y="21"
        width="33"
        height="29"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_974_27803" />
      </filter>
      <linearGradient
        id="paint0_linear_974_27803"
        x1="21.5"
        y1="20"
        x2="21.5"
        y2="35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.245" stopColor="#FFB359" />
        <stop offset="0.52" stopColor="white" />
        <stop offset="0.785" stopColor="#F956FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_974_27803"
        x1="10.5387"
        y1="15.8848"
        x2="37.5039"
        y2="42.0209"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.09" stopColor="#FFAB0C" />
        <stop offset="0.31" stopColor="#FF5538" />
        <stop offset="0.46" stopColor="#E9405D" />
        <stop offset="0.75" stopColor="#D266DA" />
        <stop offset="0.89" stopColor="#D584EF" />
      </linearGradient>
    </defs>
  </svg>
);

export const MainLogoDarkHilo = () => (
  <svg width="145" height="54" viewBox="0 0 145 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.7" filter="url(#filter0_f_974_27749)">
      <circle cx="21.5" cy="27.5" r="7.5" fill="url(#paint0_linear_974_27749)" />
    </g>
    <path
      d="M33.9994 27.0077C33.9994 20.3768 28.5999 14.9834 21.969 15C15.3899 15.0167 10.016 20.3935 10 26.9769C9.98341 33.6116 15.3726 39.0153 21.9997 39.0153H29.8845C32.1531 39.0153 33.9923 37.1748 33.9923 34.9048V27.4078C33.9968 27.2753 34 27.1421 34 27.0077H33.9994ZM15.8287 33.6763C13.9185 32.0445 12.7413 29.4339 12.7957 26.7721C12.7996 26.5858 12.8092 26.3989 12.8251 26.2132L12.8264 26.2011C13.1028 23.0252 15.1525 20.0631 18.0263 18.6874C20.9 17.3117 24.4915 17.5742 27.1356 19.3519C29.7796 21.1296 31.3783 24.3587 31.1915 27.5409C31.1506 28.2374 31.0303 28.9282 30.8627 29.6055C30.7962 29.875 30.7156 30.1541 30.5249 30.3557C30.3343 30.5574 30.0003 30.6509 29.7745 30.4895C29.5589 30.3359 29.5269 30.0337 29.5084 29.77C29.3593 27.6338 28.7893 25.4316 27.3467 23.8504C26.2572 22.6564 24.709 21.8966 23.1001 21.7474C21.4911 21.5983 19.8361 22.0579 18.5227 22.9996C17.4243 23.7876 16.5606 24.915 16.1435 26.2017C15.7264 27.4884 15.7692 28.9295 16.3175 30.1663C16.7199 31.074 17.3884 31.8621 18.2182 32.4075C19.6851 33.3716 21.6926 33.5086 23.2171 32.638C24.7416 31.7673 25.6526 29.8788 25.2643 28.1657C24.876 26.4526 23.141 25.1166 21.3951 25.2971C21.1284 25.3247 20.7471 25.2959 20.7375 25.0276C20.7298 24.8202 20.9787 24.7107 21.1827 24.6743C22.9542 24.3561 24.8517 25.2562 25.8234 26.7721C26.7952 28.288 26.8445 30.3186 26.0512 31.935C25.2579 33.5515 23.6822 34.7326 21.9338 35.1589C19.577 35.7338 17.4428 35.0539 15.8307 33.6763H15.8287Z"
      fill="url(#paint1_linear_974_27749)"
    />
    <path
      d="M58.74 19.556V35H54.978V28.642H49.126V35H45.364V19.556H49.126V25.606H54.978V19.556H58.74ZM61.1478 28.84C61.1478 27.5787 61.3825 26.4713 61.8518 25.518C62.3358 24.5647 62.9885 23.8313 63.8098 23.318C64.6311 22.8047 65.5478 22.548 66.5598 22.548C67.4251 22.548 68.1805 22.724 68.8258 23.076C69.4858 23.428 69.9918 23.89 70.3438 24.462V22.724H74.1058V35H70.3438V33.262C69.9771 33.834 69.4638 34.296 68.8038 34.648C68.1585 35 67.4031 35.176 66.5378 35.176C65.5405 35.176 64.6311 34.9193 63.8098 34.406C62.9885 33.878 62.3358 33.1373 61.8518 32.184C61.3825 31.216 61.1478 30.1013 61.1478 28.84ZM70.3438 28.862C70.3438 27.9233 70.0798 27.1827 69.5518 26.64C69.0385 26.0973 68.4078 25.826 67.6598 25.826C66.9118 25.826 66.2738 26.0973 65.7458 26.64C65.2325 27.168 64.9758 27.9013 64.9758 28.84C64.9758 29.7787 65.2325 30.5267 65.7458 31.084C66.2738 31.6267 66.9118 31.898 67.6598 31.898C68.4078 31.898 69.0385 31.6267 69.5518 31.084C70.0798 30.5413 70.3438 29.8007 70.3438 28.862ZM79.1594 21.448C78.4994 21.448 77.9568 21.2573 77.5314 20.876C77.1208 20.48 76.9154 19.996 76.9154 19.424C76.9154 18.8373 77.1208 18.3533 77.5314 17.972C77.9568 17.576 78.4994 17.378 79.1594 17.378C79.8048 17.378 80.3328 17.576 80.7434 17.972C81.1688 18.3533 81.3814 18.8373 81.3814 19.424C81.3814 19.996 81.1688 20.48 80.7434 20.876C80.3328 21.2573 79.8048 21.448 79.1594 21.448ZM81.0294 22.724V35H77.2674V22.724H81.0294ZM87.9577 18.72V35H84.1957V18.72H87.9577ZM103.246 22.724V35H99.484V33.328C99.1027 33.8707 98.582 34.3107 97.922 34.648C97.2767 34.9707 96.558 35.132 95.766 35.132C94.8273 35.132 93.9987 34.9267 93.28 34.516C92.5613 34.0907 92.004 33.482 91.608 32.69C91.212 31.898 91.014 30.9667 91.014 29.896V22.724H94.754V29.39C94.754 30.2113 94.9667 30.8493 95.392 31.304C95.8173 31.7587 96.3893 31.986 97.108 31.986C97.8413 31.986 98.4207 31.7587 98.846 31.304C99.2713 30.8493 99.484 30.2113 99.484 29.39V22.724H103.246ZM111.976 35.176C110.774 35.176 109.688 34.9193 108.72 34.406C107.767 33.8927 107.012 33.1593 106.454 32.206C105.912 31.2527 105.64 30.138 105.64 28.862C105.64 27.6007 105.919 26.4933 106.476 25.54C107.034 24.572 107.796 23.8313 108.764 23.318C109.732 22.8047 110.818 22.548 112.02 22.548C113.223 22.548 114.308 22.8047 115.276 23.318C116.244 23.8313 117.007 24.572 117.564 25.54C118.122 26.4933 118.4 27.6007 118.4 28.862C118.4 30.1233 118.114 31.238 117.542 32.206C116.985 33.1593 116.215 33.8927 115.232 34.406C114.264 34.9193 113.179 35.176 111.976 35.176ZM111.976 31.92C112.695 31.92 113.304 31.656 113.802 31.128C114.316 30.6 114.572 29.8447 114.572 28.862C114.572 27.8793 114.323 27.124 113.824 26.596C113.34 26.068 112.739 25.804 112.02 25.804C111.287 25.804 110.678 26.068 110.194 26.596C109.71 27.1093 109.468 27.8647 109.468 28.862C109.468 29.8447 109.703 30.6 110.172 31.128C110.656 31.656 111.258 31.92 111.976 31.92ZM135.332 31.59H128.644L127.412 35H125.3L130.844 19.754H133.154L138.676 35H136.564L135.332 31.59ZM134.76 29.962L131.988 22.218L129.216 29.962H134.76ZM143.534 19.666V35H141.532V19.666H143.534Z"
      fill="white"
    />
    <mask id="mask0_974_27749" maskUnits="userSpaceOnUse" x="45" y="17" width="99" height="19">
      <path d="M143.533 19.666V35H141.531V19.666H143.533Z" fill="black" />
      <path
        d="M135.331 31.5899H128.643L127.411 34.9999H125.299L130.843 19.7539H133.153L138.675 34.9999H136.563L135.331 31.5899ZM134.759 29.9619L131.987 22.2179L129.215 29.9619H134.759Z"
        fill="black"
      />
      <path
        d="M111.975 35.1759C110.772 35.1759 109.687 34.9192 108.719 34.4059C107.765 33.8925 107.01 33.1592 106.453 32.2059C105.91 31.2525 105.639 30.1379 105.639 28.8619C105.639 27.6005 105.917 26.4932 106.475 25.5399C107.032 24.5719 107.795 23.8312 108.763 23.3179C109.731 22.8045 110.816 22.5479 112.019 22.5479C113.221 22.5479 114.307 22.8045 115.275 23.3179C116.243 23.8312 117.005 24.5719 117.563 25.5399C118.12 26.4932 118.399 27.6005 118.399 28.8619C118.399 30.1232 118.113 31.2379 117.541 32.2059C116.983 33.1592 116.213 33.8925 115.231 34.4059C114.263 34.9192 113.177 35.1759 111.975 35.1759ZM111.975 31.9199C112.693 31.9199 113.302 31.6559 113.801 31.1279C114.314 30.5999 114.571 29.8445 114.571 28.8619C114.571 27.8792 114.321 27.1239 113.823 26.5959C113.339 26.0679 112.737 25.8039 112.019 25.8039C111.285 25.8039 110.677 26.0679 110.193 26.5959C109.709 27.1092 109.467 27.8645 109.467 28.8619C109.467 29.8445 109.701 30.5999 110.171 31.1279C110.655 31.6559 111.256 31.9199 111.975 31.9199Z"
        fill="black"
      />
      <path
        d="M103.246 22.7241V35.0001H99.4837V33.3281C99.1023 33.8708 98.5817 34.3108 97.9217 34.6481C97.2763 34.9708 96.5577 35.1321 95.7657 35.1321C94.827 35.1321 93.9983 34.9268 93.2797 34.5161C92.561 34.0908 92.0037 33.4821 91.6077 32.6901C91.2117 31.8981 91.0137 30.9668 91.0137 29.8961V22.7241H94.7537V29.3901C94.7537 30.2115 94.9663 30.8495 95.3917 31.3041C95.817 31.7588 96.389 31.9861 97.1077 31.9861C97.841 31.9861 98.4203 31.7588 98.8457 31.3041C99.271 30.8495 99.4837 30.2115 99.4837 29.3901V22.7241H103.246Z"
        fill="black"
      />
      <path d="M87.9573 18.7197V34.9997H84.1953V18.7197H87.9573Z" fill="black" />
      <path
        d="M79.1581 21.4479C78.4981 21.4479 77.9554 21.2573 77.5301 20.8759C77.1194 20.4799 76.9141 19.9959 76.9141 19.4239C76.9141 18.8373 77.1194 18.3533 77.5301 17.9719C77.9554 17.5759 78.4981 17.3779 79.1581 17.3779C79.8034 17.3779 80.3314 17.5759 80.7421 17.9719C81.1674 18.3533 81.3801 18.8373 81.3801 19.4239C81.3801 19.9959 81.1674 20.4799 80.7421 20.8759C80.3314 21.2573 79.8034 21.4479 79.1581 21.4479ZM81.0281 22.7239V34.9999H77.2661V22.7239H81.0281Z"
        fill="black"
      />
      <path
        d="M61.1465 28.8399C61.1465 27.5785 61.3812 26.4712 61.8505 25.5179C62.3345 24.5645 62.9872 23.8312 63.8085 23.3179C64.6298 22.8045 65.5465 22.5479 66.5585 22.5479C67.4238 22.5479 68.1792 22.7239 68.8245 23.0759C69.4845 23.4279 69.9905 23.8899 70.3425 24.4619V22.7239H74.1045V34.9999H70.3425V33.2619C69.9758 33.8339 69.4625 34.2959 68.8025 34.6479C68.1572 34.9999 67.4018 35.1759 66.5365 35.1759C65.5392 35.1759 64.6298 34.9192 63.8085 34.4059C62.9872 33.8779 62.3345 33.1372 61.8505 32.1839C61.3812 31.2159 61.1465 30.1012 61.1465 28.8399ZM70.3425 28.8619C70.3425 27.9232 70.0785 27.1825 69.5505 26.6399C69.0372 26.0972 68.4065 25.8259 67.6585 25.8259C66.9105 25.8259 66.2725 26.0972 65.7445 26.6399C65.2312 27.1679 64.9745 27.9012 64.9745 28.8399C64.9745 29.7785 65.2312 30.5265 65.7445 31.0839C66.2725 31.6265 66.9105 31.8979 67.6585 31.8979C68.4065 31.8979 69.0372 31.6265 69.5505 31.0839C70.0785 30.5412 70.3425 29.8005 70.3425 28.8619Z"
        fill="black"
      />
      <path
        d="M58.7393 19.5562V35.0002H54.9773V28.6422H49.1253V35.0002H45.3633V19.5562H49.1253V25.6062H54.9773V19.5562H58.7393Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0_974_27749)">
      <g opacity="0.4" filter="url(#filter1_f_974_27749)">
        <path
          d="M62 14C62 20.0751 51.0479 30 43.5593 30C36.0707 30 30 25.0751 30 19C30 12.9249 36.0707 8.00004 43.5593 8.00004C51.0479 8.00004 62 7.92487 62 14Z"
          fill="#CF77FF"
        />
      </g>
      <g opacity="0.4" filter="url(#filter2_f_974_27749)">
        <path
          d="M95 12.3636C95 16.7819 83.3634 24 75.4068 24C67.4501 24 61 20.4183 61 16C61 11.5817 67.4501 8.00003 75.4068 8.00003C83.3634 8.00003 95 7.94536 95 12.3636Z"
          fill="#D484FF"
        />
      </g>
      <g opacity="0.4" filter="url(#filter3_f_974_27749)">
        <ellipse cx="51.5" cy="37.5" rx="12.5" ry="5.5" fill="#FF7A66" />
      </g>
      <g opacity="0.3" filter="url(#filter4_f_974_27749)">
        <ellipse cx="41.5" cy="35.5" rx="7.5" ry="5.5" fill="#FF7FE5" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_974_27749"
        x="0"
        y="6"
        width="43"
        height="43"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_974_27749" />
      </filter>
      <filter
        id="filter1_f_974_27749"
        x="20"
        y="-2"
        width="52"
        height="42"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_974_27749" />
      </filter>
      <filter
        id="filter2_f_974_27749"
        x="51"
        y="-2"
        width="54"
        height="36"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_974_27749" />
      </filter>
      <filter
        id="filter3_f_974_27749"
        x="30"
        y="23"
        width="43"
        height="29"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_974_27749" />
      </filter>
      <filter
        id="filter4_f_974_27749"
        x="25"
        y="21"
        width="33"
        height="29"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4.5" result="effect1_foregroundBlur_974_27749" />
      </filter>
      <linearGradient
        id="paint0_linear_974_27749"
        x1="21.5"
        y1="20"
        x2="21.5"
        y2="35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.245" stopColor="#935000" />
        <stop offset="0.785" stopColor="#79007D" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_974_27749"
        x1="10.5387"
        y1="15.8848"
        x2="37.5039"
        y2="42.0209"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.09" stopColor="#FFAB0C" />
        <stop offset="0.31" stopColor="#FF5538" />
        <stop offset="0.46" stopColor="#E9405D" />
        <stop offset="0.75" stopColor="#D266DA" />
        <stop offset="0.89" stopColor="#D584EF" />
      </linearGradient>
    </defs>
  </svg>
);

// 多功能按钮
export const MultiFunctionButton = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect
      x="2.68506"
      y="2.55078"
      width="6.5"
      height="6.5"
      rx="1"
      fill="var(--col_text00)"
      fillOpacity="0.95"
    />
    <rect
      x="2.68506"
      y="10.8252"
      width="6.5"
      height="6.5"
      rx="1"
      fill="var(--col_text00)"
      fillOpacity="0.95"
    />
    <rect
      x="10.8794"
      y="10.8252"
      width="6.5"
      height="6.5"
      rx="1"
      fill="var(--col_text00)"
      fillOpacity="0.95"
    />
    <rect
      x="14.1294"
      y="1.47656"
      width="6.11537"
      height="6.11537"
      rx="1"
      transform="rotate(45 14.1294 1.47656)"
      fill="var(--col_text00)"
      fillOpacity="0.95"
    />
  </svg>
);

// 展开收起按钮
export const ExpandCollapseButtonIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M8.6286 11.0871L5.25128 7.33448C4.96169 7.01272 5.19004 6.5 5.62293 6.5H12.3776C12.8104 6.5 13.0388 7.01272 12.7492 7.33448L9.37189 11.0871C9.17327 11.3077 8.82722 11.3077 8.6286 11.0871Z"
      fill="var(--col_bg02)"
    />
  </svg>
);

export const BannerBtnIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M5 5H11V11"
      stroke="var(--col_text00)"
      strokeWidth="0.909091"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66699 11.3333L10.9999 5"
      stroke="var(--col_text00)"
      strokeWidth="0.909091"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MoonIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5788 18.9853C25.9536 19.6289 25.9397 20.4275 25.5428 21.0577C23.8643 23.7222 20.8905 25.4998 17.5 25.4998C12.2533 25.4998 8 21.2465 8 15.9998C8 10.9013 12.0154 6.7419 17.0576 6.50993C17.8016 6.47571 18.503 6.85775 18.8778 7.50139C19.2526 8.14502 19.2387 8.94361 18.8417 9.57381C18.3087 10.42 18 11.4208 18 12.4998C18 15.5373 20.4624 17.9998 23.5 17.9998C23.5868 17.9998 23.673 17.9978 23.7586 17.9938C24.5026 17.9596 25.204 18.3417 25.5788 18.9853ZM22.1286 21.9015C22.6444 21.4964 23.1058 21.0251 23.5 20.5005C23.6236 20.336 23.7405 20.1663 23.8505 19.9917C23.7343 19.9971 23.6175 19.9998 23.5 19.9998C22.8195 19.9998 22.1602 19.9091 21.5334 19.7393C18.3452 18.8753 16 15.9614 16 12.4998C16 11.8602 16.08 11.2394 16.2307 10.6468C16.4256 9.87976 16.7387 9.15994 17.1495 8.50782C16.2646 8.54853 15.4198 8.74257 14.6409 9.06399C11.917 10.1881 10 12.87 10 15.9998C10 20.1419 13.3579 23.4998 17.5 23.4998C19.2467 23.4998 20.8538 22.9027 22.1286 21.9015Z"
      fill="#222222"
    />
  </svg>
);

export const SunIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path
      d="M14 18.5C16.4853 18.5 18.5 16.4853 18.5 14C18.5 11.5147 16.4853 9.5 14 9.5C11.5147 9.5 9.5 11.5147 9.5 14C9.5 16.4853 11.5147 18.5 14 18.5Z"
      stroke="var(--col_text00)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M14 5V6.5" stroke="var(--col_text00)" strokeWidth="2" strokeLinecap="round" />
    <path d="M14 21.5V23" stroke="var(--col_text00)" strokeWidth="2" strokeLinecap="round" />
    <path d="M23 14L21.5 14" stroke="var(--col_text00)" strokeWidth="2" strokeLinecap="round" />
    <path d="M6.5 14L5 14" stroke="var(--col_text00)" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M20.3633 20.3638L19.3026 19.3031"
      stroke="var(--col_text00)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M8.69531 8.69629L7.63465 7.63563"
      stroke="var(--col_text00)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7.63672 20.3638L8.69738 19.3031"
      stroke="var(--col_text00)"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M19.3047 8.69629L20.3653 7.63563"
      stroke="var(--col_text00)"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ScreenshotLoadingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 6.5C2.5 4.84315 3.84315 3.5 5.5 3.5H18.5C20.1569 3.5 21.5 4.84315 21.5 6.5V17.5C21.5 19.1569 20.1569 20.5 18.5 20.5H5.5C3.84315 20.5 2.5 19.1569 2.5 17.5V6.5ZM5.5 5.5C4.94772 5.5 4.5 5.94772 4.5 6.5V17.5C4.5 18.0523 4.94772 18.5 5.5 18.5H18.5C19.0523 18.5 19.5 18.0523 19.5 17.5V6.5C19.5 5.94772 19.0523 5.5 18.5 5.5H5.5Z"
      fill="#FFD21E"
    />
    <path
      d="M17.0001 16.5L6.44311 16.5C6.04203 16.5 5.8042 16.0515 6.0292 15.7195L7.77921 13.1373C8.13422 12.6134 8.88037 12.5469 9.32248 12.9996L9.55885 13.2417C9.95541 13.6478 10.6101 13.6428 11.0004 13.2307L13.8188 10.2547C14.209 9.84269 14.8635 9.83756 15.2601 10.2434L17.7151 12.7555C17.8977 12.9423 17.9999 13.1931 17.9999 13.4543L18.0001 15.4999C18.0002 16.0522 17.5525 16.5 17.0001 16.5Z"
      fill="#FFD21E"
    />
    <path
      d="M8.75 8.75C8.75 9.44036 8.19036 10 7.5 10C6.80964 10 6.25 9.44036 6.25 8.75C6.25 8.05964 6.80964 7.5 7.5 7.5C8.19036 7.5 8.75 8.05964 8.75 8.75Z"
      fill="#FFD21E"
    />
  </svg>
);

export const AddNewChatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.05847 9.45752C6.05847 8.90523 6.50619 8.45752 7.05847 8.45752L13.1482 8.45752C13.7005 8.45752 14.1482 8.90523 14.1482 9.45752C14.1482 10.0098 13.7005 10.4575 13.1482 10.4575H7.05847C6.50619 10.4575 6.05847 10.0098 6.05847 9.45752Z"
      fill="currentColor"
    />
    <path
      d="M6.05847 13.4575C6.05847 12.9052 6.50619 12.4575 7.05847 12.4575H10.0623C10.6146 12.4575 11.0623 12.9052 11.0623 13.4575C11.0623 14.0098 10.6146 14.4575 10.0623 14.4575H7.05847C6.50619 14.4575 6.05847 14.0098 6.05847 13.4575Z"
      fill="currentColor"
    />
    <path
      d="M12.0132 20.5H6.07455C4.08632 20.5 2.47455 18.8882 2.47455 16.9V7.1C2.47455 5.11177 4.08632 3.5 6.07455 3.5H17.2021C19.1903 3.5 20.8021 5.11177 20.8021 7.1L20.8021 9.2371"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6006 21.7063C21.4308 21.7063 23.725 19.412 23.725 16.5819C23.725 13.7518 21.4308 11.4575 18.6006 11.4575C15.7705 11.4575 13.4763 13.7518 13.4763 16.5819C13.4763 19.412 15.7705 21.7063 18.6006 21.7063ZM19.4006 14.6531C19.4006 14.2112 19.0424 13.8531 18.6006 13.8531C18.1588 13.8531 17.8006 14.2112 17.8006 14.6531V15.7933H16.6717C16.2299 15.7933 15.8717 16.1515 15.8717 16.5933C15.8717 17.0352 16.2299 17.3933 16.6717 17.3933H17.8006V18.5109C17.8006 18.9528 18.1588 19.3109 18.6006 19.3109C19.0424 19.3109 19.4006 18.9528 19.4006 18.5109V17.3933H20.5295C20.9714 17.3933 21.3295 17.0352 21.3295 16.5933C21.3295 16.1515 20.9714 15.7933 20.5295 15.7933H19.4006V14.6531Z"
      fill="currentColor"
    />
  </svg>
);

export const OpenHistoryListIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5.25C3 4.55964 3.55964 4 4.25 4H16.25C16.9404 4 17.5 4.55964 17.5 5.25C17.5 5.94036 16.9404 6.5 16.25 6.5H4.25C3.55964 6.5 3 5.94036 3 5.25ZM3 12C3 11.3096 3.55964 10.75 4.25 10.75H19.75C20.4404 10.75 21 11.3096 21 12C21 12.6904 20.4404 13.25 19.75 13.25H4.25C3.55964 13.25 3 12.6904 3 12ZM4.25 17.5C3.55964 17.5 3 18.0596 3 18.75C3 19.4404 3.55964 20 4.25 20H16.25C16.9404 20 17.5 19.4404 17.5 18.75C17.5 18.0596 16.9404 17.5 16.25 17.5H4.25Z"
      fill="currentColor"
    />
  </svg>
);
